import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { ApiError } from '../api/client';

/**
 * Ba trạng thái lặp lại ở mọi màn hình: đang tải, lỗi, rỗng.
 *
 * Gom vào một chỗ để thông báo lỗi luôn đi qua namespace `errors` — backend
 * chỉ trả `code`, việc dịch là của tầng này (CLAUDE.md §6).
 */
export function Loading(): ReactNode {
  const { t } = useTranslation();
  return (
    <p className="feedback" role="status">
      {t('state.loading')}
    </p>
  );
}

export function ErrorNotice({
  error,
  onRetry,
}: {
  error: ApiError;
  onRetry?: () => void;
}): ReactNode {
  const { t } = useTranslation(['common', 'errors']);
  return (
    <div className="feedback feedback--error" role="alert">
      {/* Khoá không có trong `errors` thì rơi về thông báo chung, không hiện
          mã lỗi trần cho người dùng cuối. */}
      <p>{t(error.code, { ns: 'errors', defaultValue: t('state.error') })}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry}>
          {t('action.retry')}
        </button>
      ) : null}
    </div>
  );
}

export function EmptyNotice({ message }: { message?: string }): ReactNode {
  const { t } = useTranslation();
  return <p className="feedback">{message ?? t('state.empty')}</p>;
}
